import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import GET_CAMPAIGN_CONNECT_URL from "../queries/getCampaignConnectUrl.gql";

function useGetStripeConnectUrl() {
  const [getCampaignConnectUrl, { data, loading, error }] = useLazyQuery(GET_CAMPAIGN_CONNECT_URL);
  const [connectUrl, setConnectUrl] = useState();

  useEffect(() => {
    if (data && !loading) {
      const paymentMethods = data?.campaign.financialInformation.paymentMethods;
      const stripeMethod = paymentMethods.filter((method) => method.key.indexOf("stripe") > -1);
      const stripeUrl = stripeMethod[0]?.paymentMethod?.connectUrl;
      setConnectUrl(stripeUrl);
    }
  }, [data, loading]);

  return {
    getCampaignConnectUrl: (campaignId) => {
      getCampaignConnectUrl({ variables: { id: campaignId } });
    },
    connectUrl,
    loading,
    error,
  };
}

export default useGetStripeConnectUrl;
